import React from 'react';
import PropTypes from 'prop-types';

import { formatPercent } from 'helpers/formatters/number_formats';

import './styles.scss';

export default function ProgressCircle({
  percent,
  color = '#98c966', // $buildout-secondary-green - if set in CSS, it is not overridable here
  size = 60,
}) {
  const fontSize = size / 4;
  const center = size / 2;
  const strokeWidth = size / 10;
  const radius = size / 2 - strokeWidth / 2;
  const circumference = 2 * Math.PI * radius;
  const arc = circumference - percent / 100 * circumference;

  const arcProps = {
    cx: center,
    cy: center,
    r: radius,
    strokeWidth,
  };

  return (
    <svg
      className="progress-circle"
      height={size}
      width={size}
    >
      <circle
        className="circle"
        {...arcProps}
      />

      <circle
        className="progress"
        {...arcProps}
        stroke={color}
        strokeDasharray={`${circumference} ${circumference}`}
        strokeDashoffset={arc}
      />

      <text fontSize={fontSize} x="50%" y="50%">
        {formatPercent(percent / 100)}
      </text>
    </svg>
  );
}

ProgressCircle.propTypes = {
  color: PropTypes.string,
  percent: PropTypes.number.isRequired,
  size: PropTypes.number,
};
